var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockWheelEmailListIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_527_30504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.8853C17.88 12.8853 18.99 11.7653 18.99 10.3853C18.99 9.00525 17.88 7.88525 16.5 7.88525C15.12 7.88525 14 9.00525 14 10.3853C14 11.7653 15.12 12.8853 16.5 12.8853ZM9 11.8853C10.66 11.8853 11.99 10.5453 11.99 8.88525C11.99 7.22525 10.66 5.88525 9 5.88525C7.34 5.88525 6 7.22525 6 8.88525C6 10.5453 7.34 11.8853 9 11.8853ZM16.5 14.8853C14.67 14.8853 11 15.8053 11 17.6353V18.8853C11 19.4353 11.45 19.8853 12 19.8853H21C21.55 19.8853 22 19.4353 22 18.8853V17.6353C22 15.8053 18.33 14.8853 16.5 14.8853ZM9 13.8853C6.67 13.8853 2 15.0553 2 17.3853V18.8853C2 19.4353 2.45 19.8853 3 19.8853H9V17.6353C9 16.7853 9.33 15.2953 11.37 14.1653C10.5 13.9853 9.66 13.8853 9 13.8853Z",
    fill: "#9B5AF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_527_30504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.885254)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockWheelEmailListIcon);
export default __webpack_public_path__ + "static/media/LockWheelEmailListIcon.fb0f44c9767f5fbda02e554a7a6fc092.svg";
export { ForwardRef as ReactComponent };